// ===== Shared primitives =====
import React from 'react';
import { Icon } from './icons.jsx';

const { useState, useEffect, useRef, useMemo, useCallback } = React;

function HeatDot({ heat, withLabel = false }) {
  const labelMap = { hot: "Quente", warm: "Morno", cold: "Frio" };
  return (
    <span className="heat" title={`Calor: ${labelMap[heat]}`}>
      <span className={`heat-dot ${heat}`} />
      {withLabel && <span className="heat-label">{labelMap[heat]}</span>}
    </span>
  );
}

function OriginPill({ origin, agentName, compact = false }) {
  if (origin === "agente") {
    return (
      <span className="origin-pill agent" title={agentName || "Criado por agente externo"}>
        <Icon name="cpu" size={11} strokeWidth={2} />
        {!compact && (agentName || "Agente")}
      </span>
    );
  }
  return (
    <span className="origin-pill human" title="Criado por humano">
      <Icon name="user" size={11} strokeWidth={2} />
      {!compact && "Humano"}
    </span>
  );
}

function StatusPill({ status }) {
  const map = {
    abandoned: { label: "Abandonado", cls: "abandoned" },
    friction:  { label: "Atrito",     cls: "friction" },
    warn:      { label: "Atenção",    cls: "warn" },
    ok:        { label: "Saudável",   cls: "ok" },
  };
  const m = map[status] || map.ok;
  return <span className={`fh-status ${m.cls}`}><span className="d" />{m.label}</span>;
}

function StatusHTTP({ code }) {
  const bucket = code < 300 ? "s200" : code < 500 ? "s4xx" : "s5xx";
  return <span className={`status-pill ${bucket}`}>{code}</span>;
}

function Switch({ on, onChange, disabled = false, title }) {
  return <button className={`switch ${on ? "on" : ""}`} onClick={() => { if (!disabled) onChange(!on); }} aria-pressed={on} disabled={disabled} title={title} />;
}

// Toast layer
function useToast() {
  const [toasts, setToasts] = useState([]);
  const push = useCallback((t) => {
    const id = Math.random().toString(36).slice(2);
    setToasts(arr => [...arr, { id, ...t }]);
    setTimeout(() => setToasts(arr => arr.filter(x => x.id !== id)), 3200);
  }, []);
  return { toasts, push };
}

function ToastLayer({ toasts }) {
  return (
    <div style={{ position: "fixed", bottom: 22, left: "50%", transform: "translateX(-50%)", display: "flex", flexDirection: "column", gap: 8, zIndex: 300, pointerEvents: "none" }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          background: "var(--color-ink)", color: "white",
          padding: "10px 14px", borderRadius: 8, fontSize: 13,
          display: "flex", alignItems: "center", gap: 8,
          boxShadow: "0 10px 25px -8px rgba(0,0,0,0.4)",
          animation: "slidein 0.18s ease-out",
        }}>
          <Icon name={t.kind === "ok" ? "check-circle-2" : t.kind === "err" ? "alert-circle" : "info"} size={16} style={{
            color: t.kind === "ok" ? "#7BD8AF" : t.kind === "err" ? "#FFB4AC" : "#A3D5DA"
          }} />
          {t.msg}
        </div>
      ))}
    </div>
  );
}

export { HeatDot, OriginPill, StatusPill, StatusHTTP, Switch, useToast, ToastLayer };
